export default __webpack_public_path__ + "static/media/1.c39b98c2.jpg";